import Vue from 'vue'
import Vuex from 'vuex'
import { formatDate } from '@/utils/common'

Vue.use(Vuex)

const USER_LEVEL_ADMIN = 6
// 从环境变量读取，如果没有设置则默认使用 3 (production)
const ENV_TYPE = process.env.VUE_APP_ENV_TYPE
export let type = ENV_TYPE !== undefined && ENV_TYPE !== null && ENV_TYPE !== ''
  ? parseInt(ENV_TYPE, 10)
  : 3
export let baseAPI = ''
switch (type) {
  case 1: // test
    baseAPI =
      localStorage.getItem('baseAPI') != 'null' &&
        localStorage.getItem('baseAPI')
        ? localStorage.getItem('baseAPI')
        : 'https://test.kissu.site' // test
    break
  case 3: // production
    baseAPI = 'https://operate.kissu.site' // product
    break
}

// let baseUrl = '/operation/';
export let baseUrl = '/java_admin/'

let hostBaseChannels = [
  {
    label: 'gp_kissboy',
    value: 'googleplay_kissboy',
  },
  {
    label: 'ios_kissboy',
    value: 'appstore_kissboy',
  },
]

let baseUserTypes = [
  {
    label: 'New Users',
    value: 'New Users',
  },
]

let normalUserTypes = baseUserTypes.slice()
normalUserTypes.splice(0, 0, {
  label: 'All Users',
  value: 'All Users',
})

let hostNormalChannels = hostBaseChannels.slice()
hostNormalChannels.splice(0, 0, {
  label: 'all',
  value: 'all',
})

export default new Vuex.Store({
  state: {
    // 菜单
    auths: [],
    username: '',
    userLevel: '',
    token: '',
    channels: [],
    //颜值标签列表
    faceValueList: [],
    // 单位收藏收入倍率
    cr: 5,
  },
  getters: {
    username: (state) => {
      return state.username || localStorage.setItem('username_kissu')
    },
    userLevel: (state) => {
      return state.userLevel || window.$cookies.get('userLevel_kissu')
    },
    token: (state) => {
      let token = state.token || window.$cookies.get('token_kissu')
      return token
    },
    isAdmin: (state) => {
      return (
        type == 3 &&
        (state.userLevel == USER_LEVEL_ADMIN ||
          window.$cookies.get('userLevel_kissu') == USER_LEVEL_ADMIN)
      )
    },
    path() {
      return {
        login: baseAPI + baseUrl + 'login',
        video: baseAPI + baseUrl + 'statistics/chat_video',
        audio: baseAPI + baseUrl + 'statistics/chat_voice',
        users_and_vip: baseAPI + baseUrl + 'statistics/user_and_vip',
        vip: baseAPI + baseUrl + 'statistics/vip',
        pay: baseAPI + baseUrl + 'statistics/pay_goods',
        download_pay_goods: baseAPI + baseUrl + 'statistics/pay_goods/download',
        video_purchase: baseAPI + baseUrl + 'statistics/pay_video',
        life_cycle: baseAPI + baseUrl + 'statistics/life_cycle',
        follow: baseAPI + baseUrl + 'manage/follow/array',
        follow_add: baseAPI + baseUrl + 'manage/follow/add',
        follow_delete: baseAPI + baseUrl + 'manage/follow/cancel',
        user_search: baseAPI + baseUrl + 'manage/search/user',
        user_video: baseAPI + baseUrl + 'statistics/user/chat_video',
        chat_successRate: baseAPI + baseUrl + 'statistics/chat_successRate',
        user_video_detail: baseAPI + baseUrl + 'detail/user/chat_video',
        user_audio: baseAPI + baseUrl + 'statistics/user/chat_voice',
        user_audio_detail: baseAPI + baseUrl + 'detail/user/chat_voice',
        user_wallet: baseAPI + baseUrl + 'statistics/user/wallet',
        user_wallet_detail: baseAPI + baseUrl + 'detail/user/wallet',
        user_recharge: baseAPI + baseUrl + 'detail/user/pay_goods',
        user_rank: baseAPI + baseUrl + 'statistics/pay_goods/board',
        // users
        users_query_actors: baseAPI + baseUrl + 'users/query_actors',
        users_query_online_stats: baseAPI + baseUrl + 'users/query_online_stat',
        user_online_download:
          baseAPI + baseUrl + 'users/download_online_stat.xlsx',
        user_flow_manager: baseAPI + baseUrl + 'user_flow_manager/flow_stat',
        host_flow_stat: baseAPI + baseUrl + 'user_flow_manager/host_flow_stat',
        user_stat: baseAPI + baseUrl + 'user_flow_manager/user_stat',
        chat_successRate_detail:
          baseAPI + baseUrl + 'statistics/chat_successRate_detail',
        login_out: baseAPI + baseUrl + 'logout',
        chat_detail_reason: baseAPI + baseUrl + 'statistics/chat_detail_reason',
        active_source: baseAPI + baseUrl + 'user_flow_manager/active_source',
        chat_match: baseAPI + baseUrl + 'user_flow_manager/chat_match',
        query_retention: baseAPI + baseUrl + 'users/query_retention',
        download_chat_detail_reason:
          baseAPI + baseUrl + 'statistics/download/chat_detail_reason.xlsx',
        download_chat_successRate_detail:
          baseAPI +
          baseUrl +
          'statistics/download/chat_successRate_detail.xlsx',
        download_task_completed:
          baseAPI + baseUrl + 'report/download/task_completed.xlsx',
        user_signIn: baseAPI + baseUrl + 'users/signIn',
        user_signIn_download: baseAPI + baseUrl + 'users/download/sign.xlsx',
        user_smashEgg: baseAPI + baseUrl + 'users/smashEgg',
        user_smashEgg_download:
          baseAPI + baseUrl + 'users/download/smashEgg.xlsx',
        user_slotMachine: baseAPI + baseUrl + 'users/slotMachine',
        user_slotMachine_download:
          baseAPI + baseUrl + 'users/download/slotMachine.xlsx',
        user_action: baseAPI + baseUrl + 'live/action',
        user_roomOnlineStat: baseAPI + baseUrl + 'report/roomOnlineStat',
        user_roomUserOnlineStat:
          baseAPI + baseUrl + '/report/roomUserOnlineStat',
        user_roomUserOnlineStat_download:
          baseAPI + baseUrl + 'report/roomUserOnlineStat/download',
        user_action_xlsx: baseAPI + baseUrl + 'live/download/action.xlsx',
        user_liveHostStat: baseAPI + baseUrl + 'live/liveHostStat',
        user_liveHostStat_xlsx:
          baseAPI + baseUrl + 'live/liveHostStat/download',
        user_liveHostStatDetail_xlsx:
          baseAPI + baseUrl + 'live/liveHostStatDetail/download',
        user_liveHostStatDetail: baseAPI + baseUrl + 'live/liveHostStatDetail',
        // 邀请绑定
        invite_mgr_query: baseAPI + baseUrl + 'invite_mgr/check',
        invite_mgr_bind: baseAPI + baseUrl + 'invite_mgr/invite_opt',

        // 游戏BD
        game_bd_query: baseAPI + baseUrl + 'official/game_bd/query',
        game_bd_register: baseAPI + baseUrl + 'official/game_bd/register',
        game_bd_disband: baseAPI + baseUrl + 'official/game_bd/disband',
        game_bd_promotion: baseAPI + baseUrl + 'official/game_bd/promotion',

        //举报
        report_query: baseAPI + baseUrl + 'official/report/list',
        report_rule_query: baseAPI + baseUrl + 'official/report/config/list',
        report_update: baseAPI + baseUrl + 'official/report/handle',
        report_rule_update: baseAPI + baseUrl + 'official/report/config/submit',
        report_detail: baseAPI + baseUrl + 'official/report/detail',
        report_typeList: baseAPI + baseUrl + 'official/report/type/list',

        //评价
        five_star_query: baseAPI + baseUrl + 'user_assess/search',
        five_star_review: baseAPI + baseUrl + 'user_assess/review',

        // 功能封禁记录
        ban_function_query: baseAPI + baseUrl + 'official/ban_function/list',
        ban_function_update: baseAPI + baseUrl + 'official/ban_function/unban',

        // 货币风控
        money_risk_query: baseAPI + baseUrl + 'money_risk/config/list',
        money_risk_update: baseAPI + baseUrl + 'money_risk/config/update',
        money_risk_add: baseAPI + baseUrl + 'money_risk/config/add',
        money_risk_trigger_record:
          baseAPI + baseUrl + 'money_risk/trigger/record',
        money_risk_trigger_valid_change:
          baseAPI + baseUrl + 'money_risk/trigger/valid_change',

        // 账号换绑
        account_rebind_check:
          baseAPI + baseUrl + 'official/account/rebind/check_rid',
        account_rebind_do: baseAPI + baseUrl + 'official/account/rebind/do',
        account_rebind_list: baseAPI + baseUrl + 'official/account/rebind/list',

        quality_keep: baseAPI + baseUrl + 'host/quality_keep/list',
        create_batch: baseAPI + baseUrl + 'host/monitor/create/batch',
        monitor_list: baseAPI + baseUrl + 'host/monitor/list',
        monitor_del: baseAPI + baseUrl + 'host/monitor/del',
        monitor_panel: baseAPI + baseUrl + 'host/monitor/panel',
        detail_panel: baseAPI + baseUrl + 'host/monitor/panel/detail',
        download_panel:
          baseAPI + baseUrl + 'host/monitor/panel/detail/download',
        second_exam_keep: baseAPI + baseUrl + 'host/second_exam/list',
        guarantee_config:
          baseAPI + baseUrl + 'host/second_exam/guarantee_config/update',
        second_exam_download:
          baseAPI + baseUrl + 'host/second_exam/list/download',
        user_timeBox: baseAPI + baseUrl + 'live/timeBox',
        user_timeBox_xlsx: baseAPI + baseUrl + 'live/download/timeBox.xlsx',
        user_userRetention: baseAPI + baseUrl + 'retention/userRetention',
        user_userRetention_download:
          baseAPI + baseUrl + 'retention/userRetention/download',
        user_detailStat: baseAPI + baseUrl + 'live/detailStat',
        user_detailStat_download:
          baseAPI + baseUrl + 'live/detailStat/download',
        user_match_action: baseAPI + baseUrl + 'match/action',
        user_match_action_download:
          baseAPI + baseUrl + 'match/download/action.xlsx',
        user_match_fakeCallDuration:
          baseAPI + baseUrl + 'match/fakeCallDuration',
        user_match_realCallDuration:
          baseAPI + baseUrl + 'match/realCallDuration',
        settlement_detail: baseAPI + baseUrl + 'host/settlement_detail',
        settlement_detail_dwn:
          baseAPI + baseUrl + 'host/download/settlement_detail',
        // reports
        reports_download_report:
          'http://13.232.72.133:18088/download/report?name=xm&key=ZQCtHQ&date=',
        reports_download_actors: baseAPI + baseUrl + 'report/download_actors',

        // 视频推荐
        // 视频推荐-主播列表
        video_recommend_host_list:
          baseAPI + baseUrl + 'recommended_video/host_list',
        // 视频推荐-增加指定主播
        video_recommend_host_add:
          baseAPI + baseUrl + 'recommended_video/import_hosts',
        // 视频推荐-视频国家列表
        video_country: baseAPI + baseUrl + 'recommended_video/countries',
        // 视频推荐-推荐视频列表
        video_recommend: baseAPI + baseUrl + 'recommended_video/video_list',
        // 视频推荐-推荐视频更新
        video_recommend_update: baseAPI + baseUrl + 'recommended_video/update',

        // 视频巡查
        video_inspection: baseAPI + baseUrl + 'patrol/search',
        video_inspection_update: baseAPI + baseUrl + 'patrol/updateUserRobot',
        patrol_update_eva_status: baseAPI + baseUrl + 'patrol/update/eva/status',
        patrol_compensate: baseAPI + baseUrl + 'patrol/compensate',
        // 基础数据获取
        // 国家代码
        normal_country: baseAPI + baseUrl + 'country/list',
        ar_pu: baseAPI + baseUrl + 'fnc/actor/ar_pu/report',
        ar_pu_download: baseAPI + baseUrl + 'fnc/actor/ar_pu/report/download',
        // 语言    common/lang/list
        normal_language: baseAPI + baseUrl + 'language/list',
        task_config: baseAPI + baseUrl + 'report/task_config',
        face_value: baseAPI + baseUrl + 'common/host/label/face_value/list',

        // 流量统计
        reports_client_logs: baseAPI + baseUrl + 'report/client_log',
        reports_client_single_log:
          baseAPI + baseUrl + 'report/client_single_log',
        reports_download_client_logs:
          baseAPI + baseUrl + 'report/download/client_log.xlsx',
        // 收入统计
        reports_income_logs: baseAPI + baseUrl + 'report/income',
        reports_download_income:
          baseAPI + baseUrl + 'report/download/income.xlsx',
        // 订阅统计
        reports_subscription: baseAPI + baseUrl + 'report/subscription',
        reports_download_subscription:
          baseAPI + baseUrl + 'report/download/subscription.xlsx',
        // 推广成本导入
        ad_cost_query: baseAPI + baseUrl + 'fnc/ad_cost/query',
        ad_cost_excel_import_data:
          baseAPI + baseUrl + 'fnc/ad_cost/excel_import_data',
        ad_cost_import_data: baseAPI + baseUrl + 'fnc/ad_cost/import_data',
        ad_cost_del: baseAPI + baseUrl + 'fnc/ad_cost/del',
        ad_cost_channel: baseAPI + baseUrl + 'fnc/ad_cost/get_channel_list',
        // 推广成本导入(按国家细分)
        promotion_cost_query: baseAPI + baseUrl + 'fnc/promotion_cost/query',
        promotion_cost_excel_import_data:
          baseAPI + baseUrl + 'fnc/promotion_cost/excel_import_data',
        promotion_cost_del: baseAPI + baseUrl + 'fnc/promotion_cost/delData',
        // 主播评价
        reports_evaluation: baseAPI + baseUrl + 'report/evaluate',
        reports_download_evaluation:
          baseAPI + baseUrl + 'report/download/evaluation.xlsx',
        reports_download_all_host:
          baseAPI + baseUrl + 'report/download/allHost.xlsx',
        // 新用户充值分布报表
        source_list: baseAPI + baseUrl + 'source/list',
        medium_list: baseAPI + baseUrl + 'source/list/medium',
        mediumM_list: baseAPI + baseUrl + 'source/list/getMediumBySource',
        // 匹配卡领取数据
        matchCard_receive: baseAPI + baseUrl + 'matchCard/receive',
        // 匹配卡领取数据下载
        matchCard_receive_download:
          baseAPI + baseUrl + 'matchCard/download/receive.xlsx',
        // 匹配卡消耗数据
        matchCard_consume: baseAPI + baseUrl + 'matchCard/consume',
        // 匹配卡消耗数据下载
        matchCard_consume_download:
          baseAPI + baseUrl + 'matchCard/download/consume.xlsx',
        // 匹配卡转化效果数据报表
        matchCard_recharge: baseAPI + baseUrl + 'matchCard/recharge',
        // 匹配卡转化效果数据报表下载
        matchCard_recharge_download:
          baseAPI + baseUrl + 'matchCard/download/recharge.xlsx',
        // 动态列表
        reports_pay_report: baseAPI + baseUrl + 'report/pay_report',
        reports_download_pay_report:
          baseAPI + baseUrl + 'report/download/pay_report.xlsx',
        // 主播曝光
        reports_host_exposure: baseAPI + baseUrl + 'report/exposure',
        reports_task_completed: baseAPI + baseUrl + 'report/task_completed',
        reports_download_host_exposure:
          baseAPI + baseUrl + 'report/download/exposure.xlsx',
        //主播通话
        call_user: baseAPI + baseUrl + 'report/hostCalled',
        introduce_users: baseAPI + baseUrl + 'host/introduce_actor',
        download_introduce_users:
          baseAPI + baseUrl + 'host/download/introduce_actor.xlsx',
        download_call_user_report:
          baseAPI + baseUrl + 'report/download/hostCalled.xlsx',
        host_calling: baseAPI + baseUrl + 'report/hostCalling',
        download_host_calling_report:
          baseAPI + baseUrl + 'report/download/hostCalling.xlsx',
        host_match: baseAPI + baseUrl + 'report/hostMatch',
        download_host_match_report:
          baseAPI + baseUrl + 'report/download/hostMatch.xlsx',
        real_time_data: baseAPI + baseUrl + 'host/real_time_data',
        trial_host_pool: baseAPI + baseUrl + 'host/trial_host_pool',
        updateHostStatus: baseAPI + baseUrl + 'dev/updateHostStatus',
        trial_host_pool_download:
          baseAPI + baseUrl + 'host/trial_host_pool/download',
        quality_host_pool: baseAPI + baseUrl + 'host/quality_host_pool',
        gethostlevel: baseAPI + baseUrl + 'dev/updateHostLevel',
        quality_host_pool_download:
          baseAPI + baseUrl + 'host/quality_host_pool/download',
        guarantee_pool: baseAPI + baseUrl + 'host/guarantee_pool',
        guarantee_pool_download:
          baseAPI + baseUrl + 'host/guarantee_pool/download',

        income_detail: baseAPI + baseUrl + 'host/income_detail',
        income_chat_detail: baseAPI + baseUrl + 'host/chat_detail',
        income_chat_download:
          baseAPI + baseUrl + 'host/download/in_range_time_data',
        income_detail_download:
          baseAPI + baseUrl + 'host/download/income_detail',
        gradeHostRetain: baseAPI + baseUrl + 'host/gradeHostRetain',
        gradeHostRetain_download:
          baseAPI + baseUrl + 'host/download/gradeHostRetain',
        items_list: baseAPI + baseUrl + 'dev/user/items/list',
        expire_time: baseAPI + baseUrl + 'dev/user/items/update/expire_time',
        items_add: baseAPI + baseUrl + 'dev/user/items/add',
        items_update: baseAPI + baseUrl + 'dev/actor/update',
        host_online_status: baseAPI + baseUrl + 'dev/host_online_status/list',
        createHost: baseAPI + baseUrl + 'dev/createHost',
        user_flow_manager_flow_stat:
          baseAPI + baseUrl + 'user_flow_manager/flow_stat/download',
        download_active_source:
          baseAPI + baseUrl + 'user_flow_manager/active_source/download',
        download_chat_match:
          baseAPI + baseUrl + 'user_flow_manager/chat_match/download',
        pay_goods_download:
          baseAPI + baseUrl + 'user_flow_manager/host_flow_stat/download',
        user_stats_download:
          baseAPI + baseUrl + 'user_flow_manager/user_stat/download',
        reports_anchor_call: baseAPI + baseUrl + 'report/anchorCall',
        reports_download_anchor_call:
          baseAPI + baseUrl + 'report/download/anchor_call.xlsx',
        reports_newRechargeSource:
          baseAPI + baseUrl + 'report/newRechargeSource',
        reports_newRechargeSource_download:
          baseAPI + baseUrl + 'report/download/newRechargeSource.xlsx',
        reports_firstRecharge: baseAPI + baseUrl + 'report/firstRecharge',
        reports_firstRecharge_download:
          baseAPI + baseUrl + 'report/download/firstRecharge.xlsx',

        weekStar_list: baseAPI + baseUrl + 'official/week_star/config/list',
        weekStar_durations: baseAPI + baseUrl + 'official/week_star/durations',
        weekStar_create: baseAPI + baseUrl + 'official/week_star/config/create',
        weekStar_update: baseAPI + baseUrl + 'official/week_star/config/update',

        // 弹窗配置
        popup_list: baseAPI + baseUrl + 'official/game/lucky/event/list',
        popup_update_status:
          baseAPI + baseUrl + 'official/game/lucky/event/update/valid',
        popup_add: baseAPI + baseUrl + 'official/game/lucky/event/add',
        popup_update: baseAPI + baseUrl + 'official/game/lucky/event/update',
        popup_user_reward:
          baseAPI +
          baseUrl +
          'official/game/lucky/event/user_reward/data/download',
        //反馈配置
        feedback_list: baseAPI + baseUrl + 'official/feedback/query',
        feedback_reply: baseAPI + baseUrl + 'official/feedback/reply',
        //表情包配置
        // 表情包分类
        emoji_query: baseAPI + baseUrl + 'config/emoji/lib_query',
        emoji_add: baseAPI + baseUrl + 'config/emoji/lib_add',
        emoji_change: baseAPI + baseUrl + 'config/emoji/lib_change',
        //表情包列表
        emoji_list_query: baseAPI + baseUrl + 'config/emoji/config_query',
        emoji_list_add: baseAPI + baseUrl + 'config/emoji/config_add',
        emoji_list_change: baseAPI + baseUrl + 'config/emoji/config_change',
        //房间火箭
        // 奖励类型
        rocket_reward_type:
          baseAPI + baseUrl + 'official/room_rocket/item_type_query',
        // 火箭等级
        rocket_level_type:
          baseAPI + baseUrl + 'official/room_rocket/rocket_gear_query',
        // 火箭配置
        // 配置查询
        rocket_config_query:
          baseAPI + baseUrl + 'official/room_rocket/rocket_config_query',
        // 配置添加
        rocket_config_add:
          baseAPI + baseUrl + 'official/room_rocket/rocket_config_add',
        // 配置修改
        rocket_config_update:
          baseAPI + baseUrl + 'official/room_rocket/change_rocket_config',
        //奖励添加
        rocket_reward_add:
          baseAPI + baseUrl + 'official/room_rocket/add_reward',
        // 奖励删除
        rocket_reward_delete:
          baseAPI + baseUrl + 'official/room_rocket/del_reward',
        // 奖励更新
        rocket_reward_update:
          baseAPI + baseUrl + 'official/room_rocket/update_reward',
        //火箭结束
        // 房间列表tab
        room_tab_constant:
          baseAPI + baseUrl + 'official/room_list_tab_config/tab_constant',
        // 房间列表tab查询
        room_tab_list:
          baseAPI + baseUrl + 'official/room_list_tab_config/tab_list',
        // 房间列表tab添加
        room_tab_add:
          baseAPI + baseUrl + 'official/room_list_tab_config/tab_add',
        // 房间列表tab修改
        room_tab_change:
          baseAPI + baseUrl + 'official/room_list_tab_config/tab_change',
        // 房间列表tab结束
        // AB引导
        score_feedback_query:
          baseAPI + baseUrl + 'official/feedback/scoreFeedback/query',
        score_feedback_export:
          baseAPI + baseUrl + 'official/feedback/scoreFeedback/export',
        score_feedback_reply:
          baseAPI + baseUrl + 'official/feedback/scoreFeedback/reply',
        // 庆典房
        gala_type_query: baseAPI + baseUrl + 'official/event/gala/apply/list',
        gala_add: baseAPI + baseUrl + 'official/event/gala/apply/add',
        gala_update: baseAPI + baseUrl + 'official/event/gala/apply/update',
        gala_redBag_query:
          baseAPI + baseUrl + 'official/event/gala/red_envelop_rain/query',
        gala_redBag_update:
          baseAPI + baseUrl + 'official/event/gala/red_envelop_rain/update',
        // 组件化活动礼包key校验
        unit_awardsKey_batch_check:
          baseAPI + baseUrl + 'official/event/unit/awards_key/batch_check',
        unit_awardsKey_check_by_event:
          baseAPI +
          baseUrl +
          'official/event/unit/awards_key/batch_check/by_event_code',
        // 安全策略
        safe_strategy_type: baseAPI + baseUrl + 'config/safe_strategy/type',
        safe_strategy_userType:
          baseAPI + baseUrl + 'config/safe_strategy/user_type',
        safe_strategy_query:
          baseAPI + baseUrl + 'config/safe_strategy/query_config',
        safe_strategy_add:
          baseAPI + baseUrl + 'config/safe_strategy/add_config',
        safe_strategy_change:
          baseAPI + baseUrl + 'config/safe_strategy/change_config',
        // 迁移查询
        actor_migrate_query: baseAPI + baseUrl + 'actor_migrate/query_log',
        actor_source_query: baseAPI + baseUrl + 'actor_source/search',
        update_user_source: baseAPI + baseUrl + 'actor_source/update',
        actor_migrate_delete: baseAPI + baseUrl + 'actor_migrate/delete_log',
        actor_migrate_delete2: baseAPI + baseUrl + 'actor_migrate/delete_map',
        // 用户复购
        reports_repurchase: baseAPI + baseUrl + '/report/repurchase',
        reports_download_repurchase:
          baseAPI + baseUrl + 'report/download/repurchase.xlsx',
        // 用户充值数据列表
        reports_pay_repurchase: baseAPI + baseUrl + '/report/user/pay',
        reports_pay_download_repurchase:
          baseAPI + baseUrl + '/report/userPay/download',
        // managers
        managers_modify_password: baseAPI + baseUrl + 'manager/modify_password',
        // servers
        servers_query_servers: baseAPI + baseUrl + 'servers/query_servers',
        servers_restart_server: baseAPI + baseUrl + 'servers/restart_server',
        dev_query_servers: baseAPI + baseUrl + 'dev/aws/dir/list',
        dev_restart_server: baseAPI + baseUrl + 'dev/aws/file/list',
        dev_restart_del: baseAPI + baseUrl + 'dev/aws/dir/del',
        dev_file_del: baseAPI + baseUrl + 'dev/aws/file/del',
        dev_restart_upload: baseAPI + baseUrl + 'dev/aws/file/upload',
        // stats
        stats_query_golds: baseAPI + baseUrl + 'statistics/golds',
        sender_fcm: baseAPI + baseUrl + '/actormgr/sender/fcm',
        videoCallSurveillance: baseAPI + baseUrl + '/users/videoCall',

        stats_query_subscriptions:
          baseAPI + baseUrl + 'statistics/subscriptions',

        stats_query_call_reasons: baseAPI + baseUrl + 'statistics/call_reasons',
        // money
        money_operator_history_query:
          baseAPI + baseUrl + 'dev/money_operator/query_history',
        money_operator_history_delete:
          baseAPI + baseUrl + 'dev/money_operator/del_history',
        money_operator_history_operator:
          baseAPI + baseUrl + 'dev/money_operator/operator_money',
        money_operator_history_dwn:
          baseAPI + baseUrl + 'dev/money_operator/download_history',
        money_operator_config:
          baseAPI + baseUrl + 'dev/money_operator/operator_money_config',

        //gateway
        gateway_parse: baseAPI + baseUrl + 'gateway/java_bean_parse',
        gateway_refresh_config: baseAPI + baseUrl + 'gateway/refresh_config',
        // im
        im_parse: baseAPI + baseUrl + 'imGate/java_bean_parse',
        im_del: baseAPI + baseUrl + 'imGate/clear_parse_data',

        gateway_query: baseAPI + baseUrl + 'gateway/server_host_list',
        gateway_edit: baseAPI + baseUrl + 'gateway/update_server_host',
        gateway_del: baseAPI + baseUrl + 'gateway/delete_server_host',
        gateway_clear_parse_data:
          baseAPI + baseUrl + 'gateway/clear_parse_data',
        // operations
        operations_update_get_config:
          baseAPI + baseUrl + 'operation/app_update/get_config',
        operations_update_config:
          baseAPI + baseUrl + 'operation/app_update/update_config',
        operations_delete_config:
          baseAPI + baseUrl + 'operation/app_update/deleteConfig',
        operations_copy_config:
          baseAPI + baseUrl + 'operation/app_update/copy_config',
        // 配置管理
        // 匹配卡配置
        config_match_card_list: baseAPI + baseUrl + 'config/match_card/list',
        config_match_card_create:
          baseAPI + baseUrl + 'config/match_card/create',
        config_match_card_update:
          baseAPI + baseUrl + 'config/match_card/update',
        // 任务配置
        config_valid_list: baseAPI + baseUrl + 'config/task/config/valid/list',
        config_all_list: baseAPI + baseUrl + 'config/task/config/info/all/list',
        config_batch_create:
          baseAPI + baseUrl + 'config/task/config/info/batch/create',
        config_info_update:
          baseAPI + baseUrl + 'config/task/config/info/update',
        config_node_create:
          baseAPI + baseUrl + 'config/task/config/node/create',
        config_node_update:
          baseAPI + baseUrl + 'config/task/config/node/update',
        config_node_del: baseAPI + baseUrl + 'config/task/config/node/del',
        config_reward_create:
          baseAPI + baseUrl + 'config/task/config/node_relate_award/create',
        config_reward_update:
          baseAPI + baseUrl + 'config/task/config/node_relate_award/update',
        config_reward_del:
          baseAPI + baseUrl + 'config/task/config/node_relate_award/del',
        config_clone: baseAPI + baseUrl + 'config/task/config/info/clone',
        // 任务配置-新
        config_template_query: baseAPI + baseUrl + 'config/template_task/list',
        config_template_update:
          baseAPI + baseUrl + 'config/template_task/update',
        config_template_delete:
          baseAPI + baseUrl + 'config/template_task/delete',
        config_template_reset: baseAPI + baseUrl + 'config/template_task/reset',
        config_template_desc:
          baseAPI + baseUrl + 'config/template_task/task_desc',
        config_template_change:
          baseAPI + baseUrl + 'config/template_task/change_task',
        //直播开播配置
        config_live_query:
          baseAPI + baseUrl + 'config/task/host/open_live/level/list',
        config_live_create:
          baseAPI + baseUrl + 'config/task/host/open_live/level/create',
        config_live_update:
          baseAPI + baseUrl + 'config/task/host/open_live/level/update',
        config_room_node_query:
          baseAPI + baseUrl + 'config/task/host/open_live/node/list',
        config_room_node_create:
          baseAPI + baseUrl + 'config/task/host/open_live/node/create',
        config_room_node_update:
          baseAPI + baseUrl + 'config/task/host/open_live/node/update',
        //配置key_val
        config_key_list: baseAPI + baseUrl + 'config/key/list',
        config_key_create: baseAPI + baseUrl + 'config/key/create',
        config_key_update: baseAPI + baseUrl + 'config/key/update',
        config_key_updateValid: baseAPI + baseUrl + 'config/key/updateValid',
        config_val_list: baseAPI + baseUrl + 'config/val/list',
        config_val_create: baseAPI + baseUrl + 'config/val/create',
        config_val_update: baseAPI + baseUrl + 'config/val/update',
        config_val_batch_create: baseAPI + baseUrl + 'config/val/batch_create',
        config_val_type_list: baseAPI + baseUrl + 'config/key/key_type_list',
        config_val_type_add: baseAPI + baseUrl + 'config/key/key_type/create',
        // 礼物配置
        config_gift_query: baseAPI + baseUrl + 'config/gift/query',
        config_gift_changeStatus:
          baseAPI + baseUrl + 'config/gift/changeStatus',
        config_gift_add: baseAPI + baseUrl + 'config/gift/add',
        config_gift_changeGiftResource:
          baseAPI + baseUrl + 'config/gift/changeGiftResource',
        config_gift_changeGiftConfig:
          baseAPI + baseUrl + 'config/gift/changeGiftConfig',
        config_gift_changeGiftStatus:
          baseAPI + baseUrl + 'config/gift/batchChangeStatus',
        config_gift_copy: baseAPI + baseUrl + 'config/gift/copy',
        config_gift_copys: baseAPI + baseUrl + 'config/gift/copyGiftConfig',
        config_gift_change_price:
          baseAPI + baseUrl + 'config/gift/change_gift_price',

        // 定制礼物审核配置
        config_gift_customized_review_list:
          baseAPI + baseUrl + 'config/gift/customized/review/list',
        config_gift_customized_review_review:
          baseAPI + baseUrl + 'config/gift/customized/review/review',
        config_gift_customized_review_batch_review:
          baseAPI + baseUrl + 'config/gift/customized/review/batch_review',
        config_gift_customized_review_log_list:
          baseAPI + baseUrl + 'config/gift/customized/review/log/list',

        //奖励key配置
        config_rewardKey_query: baseAPI + baseUrl + 'config/awards_key/list',
        config_rewardKey_create: baseAPI + baseUrl + 'config/awards_key/add',
        config_rewardKey_update: baseAPI + baseUrl + 'config/awards_key/update',
        config_rewardKey_give: baseAPI + baseUrl + 'config/awards_key/give',
        config_rewardList_get:
          baseAPI + baseUrl + 'config/awards_key/item_info',

        //用户任务奖励配置
        config_user_task_score_list: baseAPI + baseUrl + 'config/user_task_score/list',
        config_user_task_score_submit: baseAPI + baseUrl + 'config/user_task_score/submit',
        config_user_task_score_delete: baseAPI + baseUrl + 'config/user_task_score/delete',
        config_user_task_score_reward_list: baseAPI + baseUrl + 'config/user_task_score/reward/list',
        config_user_task_score_reward_submit: baseAPI + baseUrl + 'config/user_task_score/reward/submit',
        config_user_task_score_reward_delete: baseAPI + baseUrl + 'config/user_task_score/reward/delete',

        //幸运奖池配置
        //查询幸运礼物奖池配置
        config_giftlucky_query: baseAPI + baseUrl + 'config/lucky_gift/info',
        //创建幸运礼物奖池配置
        config_giftlucky_create: baseAPI + baseUrl + 'config/lucky_gift/create',
        //更新幸运礼物奖池配置
        config_giftlucky_put: baseAPI + baseUrl + 'config/lucky_gift/update',
        //个人保底池列表
        config_giftlucky_guaranteed:
          baseAPI + baseUrl + 'config/lucky_gift/guaranteed/list',
        //幸运奖池配置结束
        //用户标签配置
        //用户标签列表
        config_userSign_query: baseAPI + baseUrl + 'config/user_sign/list',
        //更新用户标签
        config_userSign_update: baseAPI + baseUrl + 'config/user_sign/update',
        //删除用户标签
        config_userSign_delete: baseAPI + baseUrl + 'config/user_sign/delete',
        //用户标签复核
        config_userSign_review: baseAPI + baseUrl + 'config/user_sign/review',
        //用户标签人数
        config_userSign_statistic:
          baseAPI + baseUrl + 'config/user_sign/statistic',
        //用户标签人数详情
        config_userSign_statistic_detail:
          baseAPI + baseUrl + 'config/user_sign/statistic/detail',
        config_userSign_query_iphone_model_list:
          baseAPI + baseUrl + 'config/auto_message/query_iphone_model_list',
        //用户标签结束
        //策略系统
        // 自动消息复核
        config_autoMessage_review:
          baseAPI + baseUrl + 'config/auto_message/review',
        // 自动消息查询
        config_autoMessage_query:
          baseAPI + baseUrl + 'config/auto_message/query',
        // 自动消息更新
        config_autoMessage_update:
          baseAPI + baseUrl + 'config/auto_message/update',
        // 自动消息删除
        config_autoMessage_delete:
          baseAPI + baseUrl + 'config/auto_message/delete',
        // 自动消息节点查询
        config_autoMessage_queryNodes:
          baseAPI + baseUrl + 'config/auto_message/query_nodes',
        // 自动消息节点更新
        config_autoMessage_updateNode:
          baseAPI + baseUrl + 'config/auto_message/update_node',
        // 自动消息节点删除
        config_autoMessage_deleteNode:
          baseAPI + baseUrl + 'config/auto_message/delete_node',
        // 自动消息触发查询
        config_autoMessage_queryTriggers:
          baseAPI + baseUrl + 'config/auto_message/query_triggers',
        // 自动消息触发更新
        config_autoMessage_updateTrigger:
          baseAPI + baseUrl + 'config/auto_message/update_trigger',
        // 自动消息触发删除
        config_autoMessage_deleteTriggers:
          baseAPI + baseUrl + 'config/auto_message/delete_trigger',
        // 挡位奖励配置
        // 挡位类型获取
        config_gearType_query:
          baseAPI + baseUrl + 'config/gear_reward/gear_type',
        // 奖励类型获取
        config_rewardType_query:
          baseAPI + baseUrl + 'config/gear_reward/items_type',
        // 挡位配置获取
        config_gearConfig_query:
          baseAPI + baseUrl + 'config/gear_reward/query_config',
        // 挡位配置添加
        config_gearConfig_add:
          baseAPI + baseUrl + 'config/gear_reward/add_config',
        // 挡位配置修改
        config_gearConfig_post:
          baseAPI + baseUrl + 'config/gear_reward/change_config',
        //策略系统结束
        // 支付商品
        config_product_query: baseAPI + baseUrl + 'goods/product_list',
        config_update_product: baseAPI + baseUrl + 'goods/update_product',
        config_clone_product: baseAPI + baseUrl + 'goods/clone_product',
        config_delete_product: baseAPI + baseUrl + 'goods/delete_product',

        // 展示商品
        config_goods_query: baseAPI + baseUrl + 'goods/goods_list',
        config_goods_type: baseAPI + baseUrl + 'common/goods/type/list',
        config_update_goods: baseAPI + baseUrl + 'goods/update_goods',
        config_clone_goods: baseAPI + baseUrl + 'goods/clone_goods',
        config_delete_goods: baseAPI + baseUrl + 'goods/delete_goods',
        //汇率换算
        config_price_query: baseAPI + baseUrl + 'goods/price_list',
        config_price_update: baseAPI + baseUrl + 'goods/update_price',
        config_price_delete: baseAPI + baseUrl + 'goods/delete_price',

        // 货币国家关联管理
        currency_country_mapping_list:
          baseAPI + baseUrl + 'currency_country_mapping/list',
        currency_country_mapping_create:
          baseAPI + baseUrl + 'currency_country_mapping/create',
        currency_country_mapping_update:
          baseAPI + baseUrl + 'currency_country_mapping/update',
        currency_country_mapping_delete:
          baseAPI + baseUrl + 'currency_country_mapping/delete',
        // 货币详情配置
        config_currency_query:
          baseAPI + baseUrl + 'config/currency_detail/query',
        config_currency_add: baseAPI + baseUrl + 'config/currency_detail/add',
        config_currency_update:
          baseAPI + baseUrl + 'config/currency_detail/update',
        config_currency_delete:
          baseAPI + baseUrl + 'config/currency_detail/del',
        config_currencylog_query:
          baseAPI + baseUrl + 'config/currency_detail/query_log',
        // 用户余额汇率换算配置
        config_rate_query: baseAPI + baseUrl + 'config/exchange_rate/query',
        config_rate_add: baseAPI + baseUrl + 'config/exchange_rate/add',
        config_rate_update: baseAPI + baseUrl + 'config/exchange_rate/update',
        config_rate_delete: baseAPI + baseUrl + 'config/exchange_rate/del',
        config_ratelog_query:
          baseAPI + baseUrl + 'config/exchange_rate/query_log',
        // 房间物品配置
        config_roomItems_query: baseAPI + baseUrl + 'config/room_items/query',
        config_roomItems_getAccess: baseAPI + baseUrl + 'constant/desc/list',
        config_roomItems_add:
          baseAPI + baseUrl + 'config/room_items/add_config',
        config_roomItems_edit:
          baseAPI + baseUrl + 'config/room_items/change_config',
        config_roomItems_del: baseAPI + baseUrl + 'config/room_items/del_price',
        config_roomItems_price_add:
          baseAPI + baseUrl + 'config/room_items/add_price',
        config_roomItems_copy: baseAPI + baseUrl + 'config/room_items/copy',
        // 币商充值配置
        config_coin_seller_query:
          baseAPI + baseUrl + 'config/coin_seller/query_list',
        config_coin_seller_config:
          baseAPI + baseUrl + 'config/coin_seller/query_config',
        config_coin_seller_add: baseAPI + baseUrl + 'config/coin_seller/add',
        config_coin_seller_update:
          baseAPI + baseUrl + 'config/coin_seller/change',
        config_coin_seller_support:
          baseAPI + baseUrl + 'config/coin_seller/support',
        // 马甲包配置
        config_vestbag_query:
          baseAPI + baseUrl + '/config/vest_bag/mongodbQuery',
        config_vestbag_edit: baseAPI + baseUrl + 'config/vest_bag/mongodbAdd',

        // 积分抽奖配置
        config_lottery_query: baseAPI + baseUrl + 'config/drawPrize/list',
        config_lottery_add: baseAPI + baseUrl + 'config/drawPrize/create',
        config_lottery_edit: baseAPI + baseUrl + 'config/drawPrize/update',
        config_lottery_rate: baseAPI + baseUrl + 'config/drawPrize/winRate',
        config_lottery_clone: baseAPI + baseUrl + 'config/drawPrize/clone',
        config_lottery_check_reward:
          baseAPI + baseUrl + 'config/drawPrize/query_reward',
        // 主题配置
        config_theme_tab: baseAPI + baseUrl + 'config/theme/client_system_tab',
        config_theme_query: baseAPI + baseUrl + 'config/theme/config_list',
        config_theme_add: baseAPI + baseUrl + 'config/theme/create',
        config_theme_edit: baseAPI + baseUrl + 'config/theme/update',
        // 测试通用配置
        actor_config_update:
          baseAPI + baseUrl + 'config/common_test/actor_config_update',
        actor_config_delete:
          baseAPI + baseUrl + 'config/common_test/actor_config_delete',
        query_first_recharge_status:
          baseAPI + baseUrl + 'config/common_test/query_first_recharge_status',
        reset_first_recharge_status:
          baseAPI + baseUrl + 'config/common_test/reset_first_recharge_status',
        // 主播淘汰考核管理
        batch_update_appraise_score:
          baseAPI +
          baseUrl +
          'config/common_test/assessment/batch_update_appraise_score',
        update_assessment_cycle_result:
          baseAPI +
          baseUrl +
          'config/common_test/assessment/update_assessment_cycle_result',

        // 推荐列表
        recommended_config_query:
          baseAPI + baseUrl + 'config/recommended_list/rule/list',
        recommended_config_post:
          baseAPI + baseUrl + 'config/recommended_list/rule/update',
        recommended_config_add:
          baseAPI + baseUrl + 'config/recommended_list/rule/add',
        recommended_config_copy:
          baseAPI + baseUrl + 'config/recommended_list/rule/copy',
        recommended_config_delete:
          baseAPI + baseUrl + 'config/recommended_list/rule/delete',
        recommended_config_code:
          baseAPI + baseUrl + 'config/recommended_list/rule/listCode',

        // 客服中心
        replay_auto_query:
          baseAPI + baseUrl + 'config/strategy_auto_reply/query',
        replay_auto_add:
          baseAPI + baseUrl + 'config/strategy_auto_reply/create',
        replay_auto_post:
          baseAPI + baseUrl + 'config/strategy_auto_reply/update',
        replay_auto_delete:
          baseAPI + baseUrl + 'config/strategy_auto_reply/delete',

        // 会员权益
        config_benefit_query: baseAPI + baseUrl + 'member/benefits/page',
        config_benefit_add: baseAPI + baseUrl + 'member/benefits/submit',
        config_benefit_copy: baseAPI + baseUrl + 'member/benefits/copy',
        config_benefit_detail_able:
          baseAPI + baseUrl + 'member/benefits/detail/able',
        config_benefit_detail_submit:
          baseAPI + baseUrl + 'member/benefits/detail/submit',
        config_benefit_detail_list:
          baseAPI + baseUrl + 'member/benefits/detail/list',

        // 游戏配置
        config_game_list: baseAPI + baseUrl + 'config/game_config/list',
        config_game_add: baseAPI + baseUrl + 'config/game_config/add',
        config_game_update: baseAPI + baseUrl + 'config/game_config/update',
        config_game_delete: baseAPI + baseUrl + 'config/game_config/delete',
        config_game_detail: baseAPI + baseUrl + 'config/game_config/detail',

        // 积分商城配置
        point_store_list: baseAPI + baseUrl + 'point/store/list',
        point_store_reward_type: baseAPI + baseUrl + 'point/store/reward_type',
        point_store_add: baseAPI + baseUrl + 'point/store/add',
        point_store_update: baseAPI + baseUrl + 'point/store/update',
        point_store_queryItem: baseAPI + baseUrl + 'point/store/queryItem',

        // 方法监控配置
        method_monitor_query:
          baseAPI + baseUrl + 'config/event/method_monitor/config/page',
        method_monitor_Idquery:
          baseAPI + baseUrl + 'config/event/method_monitor/config/queryOne',
        method_monitor_add:
          baseAPI + baseUrl + 'config/event/method_monitor/config/add',
        method_monitor_update:
          baseAPI + baseUrl + 'config/event/method_monitor/config/update',
        method_monitor_copy:
          baseAPI + baseUrl + 'config/event/method_monitor/config/copy',
        method_monitor_toggle:
          baseAPI + baseUrl + 'config/event/method_monitor/config/toggle',

        // 培训视频配置
        config_train_video_submit:
          baseAPI + baseUrl + 'official/train/video/submit',
        config_train_video_list:
          baseAPI + baseUrl + 'official/train/video/page',
        config_train_video_delete:
          baseAPI + baseUrl + 'official/train/video/delete',
        config_train_video_tag_update:
          baseAPI + baseUrl + 'official/train/video/tag/submit',
        config_train_video_tag_list:
          baseAPI + baseUrl + 'official/train/video/tag/page',
        config_train_video_tag_delete:
          baseAPI + baseUrl + 'official/train/video/tag/delete',
        config_train_video_tag_list_all:
          baseAPI + baseUrl + 'official/train/video/tag/all',

        //机器人管理
        robot_query: baseAPI + baseUrl + 'config/robot/account/list',
        robot_update: baseAPI + baseUrl + 'config/robot/account/update',
        robot_del: baseAPI + baseUrl + 'config/robot/account/del',
        robot_status: baseAPI + baseUrl + 'config/robot/account/status',
        robot_upload: baseAPI + baseUrl + 'config/robot/account/batch_upload',

        // 机器人送礼管理
        robot_gift_query: baseAPI + baseUrl + 'config/robot_gift_config/list',
        robot_gift_add: baseAPI + baseUrl + 'config/robot_gift_config/add',
        robot_gift_edit: baseAPI + baseUrl + 'config/robot_gift_config/change',

        // 机器人头像配置
        robot_avatar_query:
          baseAPI + baseUrl + 'config/robot/account/head/list',
        robot_avatar_round:
          baseAPI + baseUrl + 'config/robot/account/head/round_config',
        robot_avatar_set_round:
          baseAPI + baseUrl + 'config/robot/account/head/use',
        robot_avatar_status:
          baseAPI + baseUrl + 'config/robot/account/head/review',

        // 道具资源配置
        prop_query: baseAPI + baseUrl + 'config/prop/query',
        prop_upload: baseAPI + baseUrl + 'config/prop/upload_ridFile',
        prop_del: baseAPI + baseUrl + 'config/prop/del',
        prop_add: baseAPI + baseUrl + 'config/prop/present',
        prop_check_cost: baseAPI + baseUrl + 'config/prop/present/check_cost',

        //房间背景
        room_background_query:
          baseAPI + baseUrl + 'config/room_background/query',
        room_background_edit:
          baseAPI + baseUrl + 'config/room_background/change_config',
        room_background_add:
          baseAPI + baseUrl + 'config/room_background/add_config',

        //提现币商管理
        withdraw_query: baseAPI + baseUrl + 'config/withdraw/partner/list',
        withdraw_edit: baseAPI + baseUrl + 'config/withdraw/partner/update',
        withdraw_add: baseAPI + baseUrl + 'config/withdraw/partner/add',
        //白名單
        white_query: baseAPI + baseUrl + 'config/whiteList/query',
        white_add: baseAPI + baseUrl + 'config/whiteList/addOne',
        white_batchAdd: baseAPI + baseUrl + 'config/whiteList/batchAdd',
        white_del: baseAPI + baseUrl + 'config/whiteList/delete',

        // 主播马甲信息
        hostmgr_list: baseAPI + baseUrl + 'hostmgr/vest/info/list',
        hostmgr_upload: baseAPI + baseUrl + 'dev/aws/file/upload',
        hostmgr_create: baseAPI + baseUrl + 'hostmgr/vest/info/create',
        hostmgr_update: baseAPI + baseUrl + 'hostmgr/vest/info/update',
        hostmgr_del: baseAPI + baseUrl + 'hostmgr/vest/info/del',
        host_list: baseAPI + baseUrl + 'hostmgr/vest/info/host/list',
        //blocked 封禁
        blocked_logs: baseAPI + baseUrl + 'exploit/blocked/logs',
        un_blocked: baseAPI + baseUrl + 'exploit/unblocked',
        blocked_report: baseAPI + baseUrl + 'exploit/download/blocked.xlsx',

        // 新折线图
        actors_config: baseAPI + baseUrl + 'users/actors_config',
        online_actors: baseAPI + baseUrl + 'users/online_actors',
        // 用户复购周期
        repurchase_cycle: baseAPI + baseUrl + 'fnc/repurchase_cycle',
        repurchase_cycle_dow:
          baseAPI + baseUrl + 'fnc/download/repurchase_cycle.xlsx',
        // 充值来源数据报表
        report_rechargeSource: baseAPI + baseUrl + 'report/rechargeSource',
        // 告警列表
        alarmList: baseAPI + baseUrl + 'dev/monitor/list',
        createAlarm: baseAPI + baseUrl + 'dev/monitor/create',
        deleteAlarm: baseAPI + baseUrl + 'dev/monitor/delete',
        modifyAlarm: baseAPI + baseUrl + 'dev/monitor/update',
        robotList: baseAPI + baseUrl + 'dev/robot/list',
        createRobot: baseAPI + baseUrl + 'dev/robot/create',
        deleteRobot: baseAPI + baseUrl + 'dev/robot/remove',
        host_exposure: baseAPI + baseUrl + 'host/exposure',
        host_exposure_download:
          baseAPI + baseUrl + 'host/download/exposure.xlsx',
        // 获取国家
        CountryList: baseAPI + baseUrl + 'country/total_list',
        channelList: baseAPI + baseUrl + 'common/channel/list',
        newChannelList: baseAPI + baseUrl + 'common/channel/auth/list',
        // channelList: baseAPI + baseUrl + 'common/agent/list',
        langList: baseAPI + baseUrl + 'language/langList',
        rewardList: baseAPI + baseUrl + 'common/material/award/list',

        //official
        notice_history: baseAPI + baseUrl + 'official/notice/history/list',
        notice_type: baseAPI + baseUrl + 'common/official_notice/act_list',
        notice_send: baseAPI + baseUrl + 'official/notice/send',

        invite_rebate_query: baseAPI + baseUrl + 'config/invite/rebate/list',
        invite_rebate_add: baseAPI + baseUrl + 'config/invite/rebate/add',
        invite_rebate_edit: baseAPI + baseUrl + 'config/invite/rebate/update',

        // 邀请拼多多转盘抽奖
        invite_lottery_query_list: baseAPI + baseUrl + 'official/lottery/query_list',
        invite_lottery_query_detail: baseAPI + baseUrl + 'official/lottery/query_detail',
        invite_lottery_add: baseAPI + baseUrl + 'official/lottery/add',
        invite_lottery_update: baseAPI + baseUrl + 'official/lottery/update',
        invite_lottery_update_valid: baseAPI + baseUrl + 'official/lottery/update_valid',

        generate_type_query:
          baseAPI + baseUrl + 'official/generate/operating/type/list',
        generate_scene_query:
          baseAPI + baseUrl + 'official/generate/operating/scene/list',
        generate_query: baseAPI + baseUrl + 'official/generate/operating/list',
        generate_add: baseAPI + baseUrl + 'official/generate/operating/create',
        generate_edit: baseAPI + baseUrl + 'official/generate/operating/update',
        generate_upp:
          baseAPI + baseUrl + 'official/generate/operating/upper_lower',
        generate_getGroup: baseAPI + baseUrl + 'config/safe_strategy/user_type',
        banner_query: baseAPI + baseUrl + 'official/host/banner/list',
        banner_add: baseAPI + baseUrl + 'official/host/banner/create',
        banner_edit: baseAPI + baseUrl + 'official/host/banner/update',
        banner_type_query:
          baseAPI + baseUrl + 'official/host/banner/jump_page/list',
        banner_upp: baseAPI + baseUrl + 'official/host/banner/upper_lower',
        // 用户信息/用户信息管理
        user_info_admin: baseAPI + baseUrl + 'users/info',
        user_info_admin_gold: baseAPI + baseUrl + 'users/info/gift_sent_gold',
        user_info_same_device: baseAPI + baseUrl + 'users/info/same_device',
        // 手机验证码查询
        sms_query: baseAPI + baseUrl + 'sms/query',
        // 更新用户基本信息
        user_info_update: baseAPI + baseUrl + 'users/info/update',
        // 设置为测试账号或取消设置为测试账号
        set_test_account: baseAPI + baseUrl + 'users/info/is_tester/update',
        // 账号删除
        del_account: baseAPI + baseUrl + 'users/info/del',
        // 账号恢复
        recover_account: baseAPI + baseUrl + 'users/info/recover',
        // 通过积分获取等级
        level_by_score: baseAPI + baseUrl + 'users/info/level_score/get_level',
        // 修改等级积分
        update_level_score: baseAPI + baseUrl + 'users/info/level_score/update',
        // 批量修改等级积分
        users_level_score_batch_update:
          baseAPI + baseUrl + 'users/info/level_score/batch_update',
        // 修改SVIP等级
        svip_level_update: baseAPI + baseUrl + 'users/info/svip_level_update',
        // 用户封禁
        user_block: baseAPI + baseUrl + 'users/info/do_block',
        // 用户解封
        user_un_block: baseAPI + baseUrl + 'users/info/do_unblock',
        // 常量通用接口
        const_all: baseAPI + baseUrl + 'constant/desc/list',
        // 房间贴纸配置信息
        room_sticker_query: baseAPI + baseUrl + 'config/room_sticker/query',
        // 房间贴纸新增
        room_sticker_add: baseAPI + baseUrl + 'config/room_sticker/add_config',
        // 房间贴纸修改
        room_sticker_edit:
          baseAPI + baseUrl + 'config/room_sticker/change_config',

        white_config_query: baseAPI + baseUrl + 'config/whiteList/queryConfig',

        // 编辑锁控制
        edit_lock_lock: baseAPI + baseUrl + 'edit_lock/lock',
        edit_lock_unlock: baseAPI + baseUrl + 'edit_lock/unlock',
        edit_lock_renew: baseAPI + baseUrl + 'edit_lock/renew',

        // 退款风控配置
        risk_config_group_list: baseAPI + baseUrl + 'risk/config/group/list',
        risk_config_group_update_valid:
          baseAPI + baseUrl + 'risk/config/group/update_valid',
        risk_config_item_list: baseAPI + baseUrl + 'risk/config/item/list',
        risk_config_item_update_valid:
          baseAPI + baseUrl + 'risk/config/item/update_valid',
        risk_config_item_update_detail:
          baseAPI + baseUrl + 'risk/config/item/update_detail',

        // 游戏房分成配置
        game_room_bill_list: baseAPI + baseUrl + 'game_room/bill/list',
        game_room_bill_refresh: baseAPI + baseUrl + 'game_room/bill/refresh',
        game_room_bill_settle: baseAPI + baseUrl + 'game_room/bill/settlement',
        game_room_bill_all_settlement:
          baseAPI + baseUrl + 'game_room/bill/settlement/all_settlement',

        // 游戏房间奖励配置
        game_room_reward_config_list:
          baseAPI + baseUrl + 'game_room/reward_config/list',
        game_room_reward_config_copy:
          baseAPI + baseUrl + 'game_room/reward_config/copy_to_next_week',
        game_room_reward_config_batch_submit:
          baseAPI + baseUrl + 'game_room/reward_config/batch_submit',

        // 概率玩法管理/幸运礼物V3配置
        pool_mgr_lucky_gift_v3_list:
          baseAPI + baseUrl + 'pool_mgr/lucky_gift/v3/list',
        pool_mgr_lucky_gift_v3_create:
          baseAPI + baseUrl + 'pool_mgr/lucky_gift/v3/create',
        pool_mgr_lucky_gift_v3_update:
          baseAPI + baseUrl + 'pool_mgr/lucky_gift/v3/update',

        // 概率玩法管理/个人奖池调控
        pool_mgr_player_pool_config_list:
          baseAPI + baseUrl + 'pool_mgr/player_pool/config/list',
        pool_mgr_player_pool_config_create:
          baseAPI + baseUrl + 'pool_mgr/player_pool/config/create',
        pool_mgr_player_pool_config_update:
          baseAPI + baseUrl + 'pool_mgr/player_pool/config/update',
        pool_mgr_player_pool_info_log_list:
          baseAPI + baseUrl + 'pool_mgr/player_pool/info_log/list',
        pool_mgr_player_pool_info_reset:
          baseAPI + baseUrl + 'pool_mgr/player_pool/info/reset',
        pool_mgr_player_pool_info_update:
          baseAPI + baseUrl + 'pool_mgr/player_pool/info/update',

        // 靓号商品配置
        premium_id_type_list:
          baseAPI + baseUrl + 'config/premium_id_product/type/list',
        premium_id_type_add:
          baseAPI + baseUrl + 'config/premium_id_product/type/add',
        premium_id_type_update:
          baseAPI + baseUrl + 'config/premium_id_product/type/update',
        premium_id_type_display_status:
          baseAPI + baseUrl + 'config/premium_id_product/type/display_status',
        premium_id_config_list:
          baseAPI + baseUrl + 'config/premium_id_product/config/list',
        premium_id_config_add:
          baseAPI + baseUrl + 'config/premium_id_product/config/add',
        premium_id_config_update:
          baseAPI + baseUrl + 'config/premium_id_product/config/update',
        premium_id_config_valid:
          baseAPI + baseUrl + 'config/premium_id_product/config/valid',
      }
    },
    dateNow() {
      let myDate = new Date()
      myDate.setDate(myDate.getDate())
      return formatDate(myDate, 'yyyy-MM-dd')
    },
    dateOneDayBefore() {
      let myDate = new Date()
      myDate.setDate(myDate.getDate() - 1)
      return formatDate(myDate, 'yyyy-MM-dd')
    },
    dateTwoDayBefore() {
      let myDate = new Date()
      myDate.setDate(myDate.getDate() - 2)
      return formatDate(myDate, 'yyyy-MM-dd')
    },
    dateOneWeekBefore() {
      let myDate = new Date()
      myDate.setDate(myDate.getDate() - 7)
      return formatDate(myDate, 'yyyy-MM-dd')
    },
    dateOneMonthBefore() {
      let myDate = new Date()
      myDate.setMonth(myDate.getMonth() - 1)
      return formatDate(myDate, 'yyyy-MM-dd')
    },
    curTime() {
      let date = new Date()
      return (date.getTime() / 1000).toString()
    },
    getType() {
      type
    },
    isProduct() {
      return type == 3
    },
    userType() {
      return normalUserTypes
    },
    hostChannels() {
      return hostNormalChannels
    },
  },
})
